
import BrandSwitcher from './navigation/BrandSwitcher';
import LocalNavigation from './navigation/LocalNavigation';

const Header = () => {
  return (
    <div className="relative">
      <BrandSwitcher />
      <LocalNavigation />
    </div>
  );
};

export default Header;
